export const LABEL_COLORS = [
  { name: "Black", value: "#000000" },
  { name: "Blue", value: "#0000ff" },
  { name: "Green", value: "#006400" },
  { name: "Turquoise", value: "#00ced1" },
  { name: "Lime", value: "#00ff00" },
  { name: "Purple", value: "#663399" },
  { name: "Red", value: "#ff0000" },
  { name: "Pink", value: "#ff69b4" },
  { name: "Orange", value: "#ff8c00" },
  { name: "Yellow", value: "#ffd700" },
];
